import { createSlice } from '@reduxjs/toolkit'


const initialState = {
    isMaintenance: false,
    detectedAt: null,
    recoveredAt: null,
   
    recoveryToken: 0,
}

const maintenanceSlice = createSlice({
    name: 'maintenance',
    initialState,
    reducers: {
        setMaintenance: (state) => {
            if (!state.isMaintenance) {
                state.isMaintenance = true
                state.detectedAt = Date.now()
            }
        },
        clearMaintenance: (state) => {
            if (state.isMaintenance) {
                state.isMaintenance = false
                state.recoveredAt = Date.now()
                state.recoveryToken += 1
            }
        },
    },
})

export const { setMaintenance, clearMaintenance } = maintenanceSlice.actions
export default maintenanceSlice.reducer
